module.exports = __webpack_public_path__ + "media/images/game/categories/pece_o_zvire-5f1e93623d237be56ad700866b195b9e.png";